import { createTheme } from "@material-ui/core/styles";
import v from "./assets/constants";
import style from "./assets/css/style";

// Configure Material UI theme
const theme = createTheme({
	palette: {
		type: "light",
		primary: {
			contrastText: "#fff",
			dark: style.color,
			light: "#7986cb",
			main: v.primary,
		},
		// h5: {
		// 	fontFamily: "Roboto, Helvetica, Arial, sans-serif",
		// 	fontSize: 12,
		// 	fontWeight: 400,
		// 	letterSpacing: "0em",
		// 	lineHeight: 1.334,
		// },
	},
});
// Button: {
// 	primary: {
// 		light: "red",
// 		main: "orange",
// 		dark: "green",
// 		contrastText: "violet",
// 		light: "#189ACA",
// 	},
// },
// 	palette: {
// 		primary: indigo,
// 		accent: orange,
// 		type: "light",
// 	},

theme.props = {
	MuiButton: {
		disableElevation: true,
		color: "primary",
		variant: "contained",
	},
	// MuiTextField: {
	// 	variant: "outlined",
	// 	fullWidth: true,
	// },
	MuiDialog: {
		maxWidth: "sm",
		fullWidth: true,
	},
	MuiSelect: {
		variant: "outlined",
		fullWidth: true,
	},
	MuiPaper: {
		elevation: 0,
		// square: true,
	},
	MuiTooltip: {
		placement: "bottom",
	},
	MuiFormControl: {
		fullWidth: true,
	},
	MuiRadio: {
		color: "primary",
	},
	MuiTextField: {
		// variant: "outlined",
		fullWidth: true,
	},
};

theme.overrides = {
	MuiButton: {
		root: {
			paddingLeft: 50,
			paddingRight: 50,
			paddingTop: 10,
			paddingBottom: 10,
			borderRadius: 21,
			fontSize: 20,
			lineHeight: 1.25,
		},
	},
	MuiCardContent: {
		root: {
			borderRadius: 10,
		},
	},
	// MuiTextField: {
	// 	root: {
	// 		"&.left-label, &.left-label div, &.left-label input": {
	// 			borderRightWidth: 0,
	// 		},
	// 	},
	// },
};

// console.log(theme);

export default theme;
